const LrConfigurationConstants = {
  defaultClientValue: {
    short_code: '',
  },
  defaultDepotValue: {
    short_code: '',
    auto_generation_enabled: false,
  },
};

module.exports = { LrConfigurationConstants };
